export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line"></i>
              <span>韩漫 · 日漫 · 国漫</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-3">
              尾巴漫画
              <span className="block text-primary-500 text-2xl md:text-3xl lg:text-4xl mt-1">
                免费在线漫画阅读平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              尾巴漫画是专注中文读者的免费漫画在线阅读平台，收录海量韩漫、日漫与国漫资源，支持下拉式竖屏阅读。
              每日同步更新热门连载，从热血战斗到恋爱甜漫、悬疑推理到奇幻冒险，分类清晰、检索便捷，追更不等待，好看漫画一网打尽。
              当前夏季新番专题火热上线，《我独自升级》《剑尊归来》等高人气作品持续爆更中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-500">8000万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">注册用户</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-500">5万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">漫画资源</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-0.5">同步追更</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline text-center"
              >
                立即免费阅读
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer no-underline text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20manga%20and%20comic%20reading%20scene%20with%20colorful%20floating%20comic%20panels%20and%20dynamic%20character%20silhouettes%20in%20action%20poses%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20modern%20digital%20tablet%20displaying%20manga%20pages%20in%20the%20center%2C%20playful%20reading%20atmosphere%2C%20soft%20gradient%20background%20with%20subtle%20comic%20dot%20patterns%2C%20artistic%20composition%2C%20clean%20and%20inviting%20illustration%20style%2C%20high%20detail&width=960&height=720&seq=hero-manga-visual&orientation=landscape"
                alt="尾巴漫画 - 免费漫画在线阅读平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}